import { render, staticRenderFns } from "./header.vue?vue&type=template&id=5fe856a2&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=5fe856a2&prod&lang=css&"
import style1 from "./header.vue?vue&type=style&index=1&id=5fe856a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe856a2",
  null
  
)

export default component.exports